var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPublicPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.000000, -51.000000) translate(67.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#6E6259",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M6 0c3.308 0 6 2.617 6 5.833 0 1.563-.974 3.57-2.894 5.964-.88 1.094-1.833 2.131-2.852 3.104-.142.132-.366.132-.508 0-1.02-.973-1.972-2.01-2.852-3.104C.974 9.402 0 7.396 0 5.833 0 2.617 2.692 0 6 0zm0 1.667c-2.363 0-4.286 1.869-4.286 4.166C1.714 8.131 3.637 10 6 10c2.363 0 4.286-1.869 4.286-4.167 0-2.297-1.923-4.166-4.286-4.166z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 5.909,
    fill: "#6E6259",
    rx: 4.615,
    ry: 4.545
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 5.909,
    fill: "#FFF",
    rx: 2.308,
    ry: 2.273
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPublicPlace);
export default __webpack_public_path__ + "static/media/logo-public-place.d861a763.svg";
export { ForwardRef as ReactComponent };